/* tslint:disable */
/* eslint-disable */

/**
 * partnerDriverWeb driver-auth api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, GeneratedHttpClientConstraints, RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    AuthenticateResponse,
    AuthenticateWithMagicLinkRequestBody,
    BrandEnum,
    ConfirmAuthenticationRequest,
    GetAccessTokenResponse,
    RefreshTokenRequest,
    ResendVerificationCodeRequest,
    ResendVerificationCodeResponse,
    StartAuthenticationBase,
    StartAuthenticationResponse,
    V2ConfirmAuthentication200ResponseData,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.NONE;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}

export interface AuthenticateWithMagicLinkRequest {
    version: string;
    session_id?: string;
    brand?: BrandEnum;
}
export interface VehicleMarketplaceAuthenticateWithMagicLinkRequest {
    version: string;
    session_id?: string;
    brand?: BrandEnum;
}


class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public authenticateWithMagicLink = async (query: AuthenticateWithMagicLinkRequest, body: AuthenticateWithMagicLinkRequestBody, opts?: TRequestOptions): Promise<AuthenticateResponse>  => {
            return this.httpClient.sendRequest<AuthenticateResponse>({
                path: '/partnerDriverWeb/authenticateWithMagicLink',
                service_id: 'driver-auth',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
        public getAccessToken = async (body: RefreshTokenRequest, opts?: TRequestOptions): Promise<GetAccessTokenResponse>  => {
            return this.httpClient.sendRequest<GetAccessTokenResponse>({
                path: '/partnerDriverWeb/getAccessToken',
                service_id: 'driver-auth',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public resendVerificationCode = async (body: ResendVerificationCodeRequest, opts?: TRequestOptions): Promise<ResendVerificationCodeResponse>  => {
            return this.httpClient.sendRequest<ResendVerificationCodeResponse>({
                path: '/partnerDriverWeb/resendVerificationCode',
                service_id: 'driver-auth',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public startAuthentication = async (body: StartAuthenticationBase, opts?: TRequestOptions): Promise<StartAuthenticationResponse>  => {
            return this.httpClient.sendRequest<StartAuthenticationResponse>({
                path: '/partnerDriverWeb/startAuthentication',
                service_id: 'driver-auth',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public v2ConfirmAuthentication = async (body: ConfirmAuthenticationRequest, opts?: TRequestOptions): Promise<V2ConfirmAuthentication200ResponseData>  => {
            return this.httpClient.sendRequest<V2ConfirmAuthentication200ResponseData>({
                path: '/partnerDriverWeb/v2/confirmAuthentication',
                service_id: 'driver-auth',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public vehicleMarketplaceAuthenticateWithMagicLink = async (query: VehicleMarketplaceAuthenticateWithMagicLinkRequest, body: AuthenticateWithMagicLinkRequestBody, opts?: TRequestOptions): Promise<AuthenticateResponse>  => {
            return this.httpClient.sendRequest<AuthenticateResponse>({
                path: '/partnerDriverWeb/vehicleMarketplace/authenticateWithMagicLink',
                service_id: 'driver-auth',
                subdomain: 'partnerdriverweb',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: false },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
                query,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
